<template>
  <div>
    <footer class="mdn-Footer mdn-Footer--social mdn-Footer--signature">
      <div class="mdn-Container">
        <div class="mdn-Footer-content">
          <div class="mdn-Footer-social-and-disclaimer">
            <div class="mdn-Footer-disclaimer">
              <p class="mdn-Text mdn-Text--caption mdn-Text--inverse">
                <a
                  class="mdn-Footer-disclaimer-link"
                  href="https://www.claro.com.br/privacidade/politica-de-privacidade"
                  target="_blank"
                  >Política de Privacidade</a
                >
                <a
                  class="mdn-Footer-disclaimer-link"
                  href="https://www.claro.com.br/privacidade"
                  target="_blank"
                  >Portal de Privacidade</a
                >
                <a>
                  <LibrasButton :is-disclaimer="true" />
                </a>
              </p>
              <p class="mdn-Text mdn-Text--caption mdn-Text--inverse">
                <strong
                  >© Claro - CNPJ: 40.432.544/0001- 47 <br />
                  Rua Henri Dunant, 780 - São Paulo - SP</strong
                >
              </p>
            </div>
          </div>
          <div class="mdn-Footer-logo"></div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script lang="ts">
import Vue from "vue";

import { Component } from "vue-property-decorator";
import LibrasButton from "@/components/header/components/LibrasButton/index.vue";

@Component({
  name: "Footer",
  components: {
    LibrasButton,
  },
})
export default class Footer extends Vue {}
</script>

<style lang="scss" scoped>
.mdn-Footer-disclaimer {
  a {
    color: inherit;
  }
}
</style>
